/* ==========================================================================
   PMP — Temporisation du pop-up Omnisend (2026-09-01)

   PROBLEME CONSTATE
   Sur mobile, le formulaire Omnisend « YOUR PET DESERVES THE FINEST /
   CLAIM MY 10% OFF » s'affiche des l'arrivee et recouvre la totalite de
   l'ecran sur les pages d'article. Un visiteur venu de Google ne voit pas
   une ligne du contenu. Le pop-up verrouille en plus le defilement.
   C'est une cause tres probable des 39 % de sessions a zero clic et de
   l'echec du tunnel article -> produit releves dans Clarity.

   CE QUE FAIT CE FICHIER
   Le pop-up n'apparait plus a l'arrivee mais au premier des deux signaux :
     - le visiteur amorce un defilement (wheel / touchmove / scroll / clavier)
     - ou 20 secondes se sont ecoulees.

   Pendant l'attente, le formulaire est rendu invisible et non cliquable, et
   le verrou de defilement pose par l'app est neutralise : sans cela le
   visiteur ne pourrait pas scroller, et le declencheur « au scroll » ne
   pourrait jamais se produire.

   FAIL-SAFE
   La classe de masquage est posee par JS. Si ce script ne s'execute pas, ou
   si Omnisend change ses identifiants, le pop-up reprend simplement son
   comportement actuel : aucune regression possible.

   LIMITE CONNUE
   Ceci masque le formulaire, cela ne l'empeche pas d'etre « affiche » du
   point de vue d'Omnisend. Les statistiques d'impression de l'app peuvent
   donc rester comptees a l'arrivee. Le reglage durable est cote Omnisend :
   Formulaires > le formulaire > Affichage / Declencheur.
   ========================================================================== */

(function () {
  'use strict';

  var GATE_CLASS = 'pmp-cf-gate';
  var DELAY_MS = 20000;
  var html = document.documentElement;
  var released = false;

  /* Pas de temporisation la ou le pop-up n'a pas lieu d'etre gene. */
  if (/\/(cart|checkout|account)(\/|$)/.test(window.location.pathname)) return;

  /* 1. Masquage immediat + neutralisation du verrou de defilement. */
  var style = document.createElement('style');
  style.id = 'pmp-cf-popup-gate-style';
  style.textContent =
    'html.' + GATE_CLASS + ' #omnisend-forms-container,' +
    'html.' + GATE_CLASS + ' #omnisend-forms-wrapper,' +
    'html.' + GATE_CLASS + ' [id^="omnisend-form"],' +
    'html.' + GATE_CLASS + ' [class*="omnisend-form"]{' +
      'visibility:hidden!important;pointer-events:none!important;' +
    '}' +
    /* Sans ceci, le verrou pose par l'app empeche tout defilement et le
       declencheur « au scroll » ne peut jamais se produire. */
    'html.' + GATE_CLASS + ',html.' + GATE_CLASS + ' body{' +
      'overflow:auto!important;position:static!important;height:auto!important;' +
    '}';
  (document.head || html).appendChild(style);
  html.classList.add(GATE_CLASS);

  /* 2. Liberation. */
  function release() {
    if (released) return;
    released = true;
    html.classList.remove(GATE_CLASS);
    ['wheel', 'touchmove', 'scroll', 'keydown'].forEach(function (evt) {
      window.removeEventListener(evt, onIntent, true);
    });
  }

  function onIntent(e) {
    /* Les touches de navigation seulement : on ne libere pas sur une saisie. */
    if (e.type === 'keydown') {
      var keys = ['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', ' ', 'End', 'Home'];
      if (keys.indexOf(e.key) === -1) return;
    }
    release();
  }

  /* wheel et touchmove se declenchent meme quand le defilement est verrouille :
     ce sont les signaux d'intention les plus fiables. */
  ['wheel', 'touchmove', 'scroll', 'keydown'].forEach(function (evt) {
    window.addEventListener(evt, onIntent, { capture: true, passive: true });
  });

  setTimeout(release, DELAY_MS);

  /* Filet : si la page est quittee/masquee puis revue, on ne bloque jamais. */
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') release();
  });
})();
